// src/utils/CorrecaoEnderecoUtils.js
const CHAVE = 'correcaoEnderecoPedido';
const texto = (valor) => String(valor ?? '').trim();

export const criarCorrecaoEndereco = (inicial, atual, campos = ['logradouro', 'numero', 'bairro', 'complemento']) =>
  Object.fromEntries(campos.filter(campo => texto(inicial?.[campo]) !== texto(atual?.[campo]))
    .map(campo => [campo, campo === 'cidadeId' ? Number(atual[campo]) : texto(atual?.[campo])]));

export const lerRascunhoCorrecao = () => {
  try {
    const salvo = JSON.parse(localStorage.getItem(CHAVE));
    return salvo?.token === localStorage.getItem('token') && salvo.campos && salvo.originais
      && typeof salvo.campos === 'object' && typeof salvo.originais === 'object' ? salvo : null;
  } catch { return null; }
};

export const registrarCorrecaoEndereco = (campo, inicial, valor, cidadeId = null) => {
  const rascunho = lerRascunhoCorrecao() || { token: localStorage.getItem('token'), originais: {}, campos: {} };
  if (!Object.prototype.hasOwnProperty.call(rascunho.originais, campo)) rascunho.originais[campo] = texto(inicial);
  if (texto(valor) === rascunho.originais[campo]) delete rascunho.campos[campo];
  else rascunho.campos[campo] = texto(valor);
  if (cidadeId) rascunho.cidadeId = Number(cidadeId);
  localStorage.setItem(CHAVE, JSON.stringify(rascunho));
};

export const obterCorrecaoEnderecoPedido = () => {
  const rascunho = lerRascunhoCorrecao();
  if (!rascunho || !Object.keys(rascunho.campos).length) return null;
  return { ...rascunho.campos, ...(rascunho.cidadeId ? { cidadeId: rascunho.cidadeId } : {}) };
};

export const restaurarRascunhoCorrecao = (rascunho) => {
  if (rascunho) localStorage.setItem(CHAVE, JSON.stringify(rascunho));
  else localStorage.removeItem(CHAVE);
};

export const limparCorrecaoEnderecoPedido = () => localStorage.removeItem(CHAVE);
